module.exports = __webpack_public_path__ + "img/bird-4-left.c41ab112.png";